/* eslint-disable */
import React, { useCallback, useContext, useState } from "react";
import styled from "styled-components";
import moment from "moment";
import { Delete } from "@material-ui/icons";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";

import { Grid, Column } from "../../../../theme/Grid";
import Input from "../../../../theme/CustomMUI/Input";
import Select from "../../../../theme/CustomMUI/Select";
import DatePickerInput from "../../../../theme/CustomMUI/DatePickerInput";
import AppContext from "../../../../context/store";

const themeForDatePicker = createTheme({
  typography: { fontSize: 11 },
});

export const getGroupedPayments = (checkout_data) => {
  if (!checkout_data || !checkout_data.paids) return [];

  const positiveMatchGroups = {};
  const zeroOrNullMatchPayments = [];

  Object.values(checkout_data.paids)
    .filter((payment) => payment !== undefined)
    .forEach((payment) => {
      const normalizedPayment = { ...payment };

      if (normalizedPayment.payment_type !== undefined) {
        normalizedPayment.payment_type = Number(normalizedPayment.payment_type);
      }
      if (normalizedPayment.pay_amount !== undefined) {
        normalizedPayment.pay_amount =
          Math.round(parseFloat(normalizedPayment.pay_amount) * 100) / 100;
      }

      if (
        normalizedPayment.match &&
        typeof normalizedPayment.match === "number" &&
        normalizedPayment.match > 0
      ) {
        if (!positiveMatchGroups[normalizedPayment.match]) {
          positiveMatchGroups[normalizedPayment.match] = [];
        }
        positiveMatchGroups[normalizedPayment.match].push(normalizedPayment);
      } else {
        zeroOrNullMatchPayments.push(normalizedPayment);
      }
    });

  const groupedResults = Object.entries(positiveMatchGroups).map(
    ([matchValue, payments]) => {
      const totalAmount = payments.reduce(
        (sum, payment) => sum + parseFloat(payment.pay_amount || 0),
        0
      );
      return {
        matchId: parseInt(matchValue),
        payments,
        payment_date: payments[0].payment_date,
        payment_type: Number(payments[0].payment_type),
        staff_id: payments[0].staff_id,
        total_amount: totalAmount,
        payment_count: payments.length,
        isGroup: payments.length > 1,
      };
    }
  );

  const individualResults = zeroOrNullMatchPayments.map((payment) => ({
    matchId: payment.id,
    payments: [payment],
    payment_date: payment.payment_date,
    payment_type: Number(payment.payment_type),
    staff_id: payment.staff_id,
    total_amount: parseFloat(payment.pay_amount || 0),
    payment_count: 1,
    isGroup: false,
  }));

  return [...groupedResults, ...individualResults];
};

const getSaleItemOptions = (checkout_data, services, stockItems) => [
  { label: "Genel Ödeme", value: null, type: null },
  ...Object.values(checkout_data?.services || {})
    .filter((service) => service !== undefined)
    .map((service) => ({
      label:
        services.find((s) => s.id === service.service_id)?.name ||
        "Bilinmeyen Servis",
      value: service.id,
      type: 1,
    })),
  ...Object.values(checkout_data?.packages || {})
    .filter((pkg) => pkg !== undefined)
    .map((pkg) => ({
      label:
        services.find((s) => s.id === pkg.service_id)?.name ||
        "Bilinmeyen Seans",
      value: pkg.id,
      type: 2,
    })),
  ...Object.values(checkout_data?.groupsAmount || {})
    .filter((group) => group !== undefined)
    .map((group) => ({
      label: group.package_name || "Bilinmeyen Paket",
      value: group.id,
      type: 2,
    })),
  ...Object.values(checkout_data?.sales || {})
    .filter((sale) => sale !== undefined)
    .map((sale) => ({
      label:
        stockItems.find((s) => s.id === sale.stock_item_id)?.name ||
        "Bilinmeyen Ürün",
      value: sale.id,
      type: 3,
    })),
];

const NoDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px;

  img {
    width: 60%;
    max-width: 200px;
    margin-bottom: 16px;
  }

  p {
    color: #666;
    text-align: center;
  }
`;

export const GroupedPaymentsList = ({
  checkout_data,
  setCheckoutData,
  staffs,
  services = [],
  stockItems = [],
  deleteSingleReceiptPayment,
  onDeletePayment,
}) => {
  const context = useContext(AppContext);
  const [expandedMatch, setExpandedMatch] = useState(null);
  const [inputValues, setInputValues] = useState({});
  const [paymentDetailValue, setPaymentDetailValue] = useState({});

  const groupedPayments = getGroupedPayments(checkout_data);

  const handlePaymentChange = useCallback(
    (paymentId, updatedData) => {
      if (!checkout_data || !updatedData) return;

      const paymentKey = Object.keys(checkout_data.paids || {}).find(
        (key) => checkout_data.paids[key]?.id === paymentId
      );

      if (!paymentKey || !checkout_data.paids[paymentKey]) return;

      const payment = checkout_data.paids[paymentKey];

      if (payment.match && payment.match > 0 && "pay_amount" in updatedData) {
        const matchedPaymentKeys = Object.keys(checkout_data.paids || {}).filter(
          (key) =>
            checkout_data.paids[key]?.match === payment.match &&
            checkout_data.paids[key] !== undefined
        );

        if (matchedPaymentKeys.length > 1) {
          const exactTotalAmount = parseInt(updatedData.pay_amount || 0);
          const updatedCheckoutData = { ...checkout_data };
          let runningTotal = 0;

          for (let i = 0; i < matchedPaymentKeys.length - 1; i++) {
            const key = matchedPaymentKeys[i];
            const currentPayment = checkout_data.paids[key];
            const currentAmount = parseFloat(currentPayment.pay_amount || 0);
            runningTotal += currentAmount;
            updatedCheckoutData.paids[key] = {
              ...currentPayment,
              pay_amount: currentAmount,
            };
          }

          const lastKey = matchedPaymentKeys[matchedPaymentKeys.length - 1];
          const lastPayment = checkout_data.paids[lastKey];
          const lastAmount = Math.max(0, exactTotalAmount - runningTotal);

          updatedCheckoutData.paids[lastKey] = {
            ...lastPayment,
            pay_amount: lastAmount,
          };

          setCheckoutData(updatedCheckoutData);
          return;
        }
      }

      const updatedPayment = { ...payment, ...updatedData };
      if (updatedData.payment_type !== undefined) {
        updatedPayment.payment_type = Number(updatedData.payment_type);
      }
      if (updatedData.pay_amount !== undefined) {
        updatedPayment.pay_amount = parseFloat(updatedData.pay_amount);
      }

      setCheckoutData({
        ...checkout_data,
        paids: {
          ...checkout_data.paids,
          [paymentKey]: updatedPayment,
        },
      });
    },
    [checkout_data, setCheckoutData]
  );

  const handleDeletePayment = (paymentId) => {
    if (onDeletePayment) {
      onDeletePayment(paymentId);
      return;
    }
    if (deleteSingleReceiptPayment) {
      deleteSingleReceiptPayment(checkout_data.receipt_id, paymentId);
      const paymentKey = Object.keys(checkout_data.paids || {}).find(
        (key) => checkout_data.paids[key]?.id === paymentId
      );
      if (paymentKey) {
        setCheckoutData({
          ...checkout_data,
          paids: {
            ...checkout_data.paids,
            [paymentKey]: undefined,
          },
        });
      }
    }
  };

  const saleItemOptions = getSaleItemOptions(checkout_data, services, stockItems);

  if (groupedPayments.length === 0) {
    return (
      <NoDataContainer>
        <img
          src={require("../../../../assets/images/manypixels/online_payment_.svg")}
          alt="Malesef bulunamadı!"
        />
        <p>{context.t(`['receipt/detail/id'].payments.noDataText`)}</p>
      </NoDataContainer>
    );
  }

  return (
    <>
      {groupedPayments.map((group, groupIndex) => (
        <React.Fragment key={`group-${group.matchId}-${groupIndex}`}>
          <Grid
            className="no-gutters-row"
            style={{
              marginBottom: "10px",
              borderBottom: "1px solid #e5e5e5",
              paddingBottom: "5px",
            }}
          >
            <Column className="xs-12 sm-6 md-4 mt-1 lg-2">
              <MuiThemeProvider theme={themeForDatePicker}>
                <DatePickerInput
                  label={context.t(
                    `['receipt/detail/id'].payments.dateInputLabel`
                  )}
                  value={new Date(
                    moment(group.payment_date).local().toISOString()
                  )}
                  onChange={(payment_date) => {
                    group.payments.forEach((payment) => {
                      handlePaymentChange(payment.id, {
                        ...payment,
                        payment_date,
                      });
                    });
                  }}
                />
              </MuiThemeProvider>
            </Column>

            <Column className="xs-6 sm-6 md-4 lg-2">
              <Select
                label={context.t(
                  `['receipt/detail/id'].payments.typeInputLabel`
                )}
                items={[
                  {
                    label: context.t(`['receipt/detail/id'].payments.typeCASH`),
                    value: "0",
                  },
                  {
                    label: context.t(`['receipt/detail/id'].payments.typeCARD`),
                    value: "1",
                  },
                  {
                    label: context.t(`['receipt/detail/id'].payments.typeEFT`),
                    value: "2",
                  },
                  {
                    label: context.t(`['receipt/detail/id'].payments.typePOINT`),
                    value: "3",
                  },
                ]}
                selected={String(Number(group.payment_type))}
                labelKey="label"
                valueKey="value"
                handler={(payment_type) => {
                  const paymentType = Number(payment_type);
                  group.payments.forEach((payment) => {
                    handlePaymentChange(payment.id, {
                      ...payment,
                      payment_type: paymentType,
                    });
                  });
                }}
              />
            </Column>

            <Column className="xs-12 sm-6 md-4 lg-2">
              <Select
                label={"İşlem Adı"}
                items={saleItemOptions}
                selected={group.payments[0]?.sale_id || null}
                labelKey="label"
                valueKey="value"
                handler={(item) => {
                  const selectedItem =
                    item && typeof item === "object"
                      ? item
                      : { value: item, type: null };
                  group.payments.forEach((payment) => {
                    handlePaymentChange(payment.id, {
                      ...payment,
                      sale_id: selectedItem.value,
                      sale_type: selectedItem.type,
                    });
                  });
                }}
              />
            </Column>

            <Column className="xs-6 sm-6 md-4 lg-2">
              <Select
                label={context.t(`["receipt/detail/id"].headingTitles.staff`)}
                items={staffs}
                selected={group.staff_id || ""}
                labelKey="full_name"
                valueKey="id"
                handler={(staff_id) => {
                  const parsedStaffId = parseInt(staff_id);
                  group.payments.forEach((payment) => {
                    handlePaymentChange(payment.id, {
                      ...payment,
                      staff_id: parsedStaffId,
                    });
                  });
                }}
              />
            </Column>

            <Column className="xs-6 sm-6 md-4 lg-2">
              <Input
                label={
                  group.payment_type === 3
                    ? context.t(
                        `['receipt/detail/id'].payments.pointInputLabel`
                      )
                    : context.t(
                        `['receipt/detail/id'].payments.amountInputLabel`
                      ) +
                      (context.state.currency
                        ? "(" + context.state.currency + ")"
                        : "₺")
                }
                type="text"
                value={
                  inputValues[`group-${group.matchId}`] !== undefined
                    ? inputValues[`group-${group.matchId}`]
                    : group.total_amount
                    ? group.total_amount.toString()
                    : ""
                }
                onChange={(e) => {
                  const inputText = e.target.value.replace(/[^\d]/g, "");
                  setInputValues({
                    ...inputValues,
                    [`group-${group.matchId}`]: inputText,
                  });
                }}
                onBlur={() => {
                  if (inputValues[`group-${group.matchId}`] !== undefined) {
                    const exactValue =
                      inputValues[`group-${group.matchId}`] === ""
                        ? 0
                        : parseInt(inputValues[`group-${group.matchId}`]);

                    if (group.payments && group.payments.length > 0) {
                      let referencePaymentId = group.payments[0].id;
                      if (group.payments.length > 1) {
                        referencePaymentId =
                          group.payments[group.payments.length - 1].id;
                      }
                      handlePaymentChange(referencePaymentId, {
                        pay_amount: exactValue,
                      });
                    }
                  }
                }}
              />
            </Column>

            {group.isGroup ? (
              <Column
                className="xs-6 sm-6 md-8 lg-1 ml-2"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      expandedMatch === group.matchId ? "#FF9016" : "#3189EC",
                    borderRadius: "5px",
                    padding: "5px 10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
                    minWidth: "80px",
                    cursor: "pointer",
                    marginTop: "-25px",
                  }}
                  onClick={() => {
                    setExpandedMatch(
                      expandedMatch === group.matchId ? null : group.matchId
                    );
                  }}
                >
                  {expandedMatch === group.matchId ? (
                    <>
                      <ExpandLessIcon
                        style={{
                          color: "white",
                          fontSize: "20px",
                          marginRight: "3px",
                        }}
                      />
                      <span style={{ color: "white", fontSize: "12px" }}>
                        Gizle
                      </span>
                    </>
                  ) : (
                    <>
                      <ExpandMoreIcon
                        style={{
                          color: "white",
                          fontSize: "20px",
                          marginRight: "3px",
                        }}
                      />
                      <span style={{ color: "white", fontSize: "12px" }}>
                        Detay ({group.payment_count})
                      </span>
                    </>
                  )}
                </div>
              </Column>
            ) : (
              <Column
                className="xs-3 sm-3 md-2 lg-1"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Delete
                  onClick={() => handleDeletePayment(group.payments[0].id)}
                  style={{
                    cursor: "pointer",
                    color: "red",
                    fontSize: "24px",
                  }}
                />
              </Column>
            )}
          </Grid>

          {expandedMatch === group.matchId && (
            <div
              style={{
                marginLeft: "20px",
                marginBottom: "20px",
                borderLeft: "2px solid #3189EC",
                paddingLeft: "10px",
              }}
            >
              {group.payments.map((payment, index) => (
                <Grid
                  className="no-gutters-row"
                  key={`detail-${payment.id}-${index}`}
                  style={{ marginBottom: "10px" }}
                >
                  <Column className="xs-12 sm-12 md-12 lg-2">
                    <Input
                      label={"Ödeme Tarihi"}
                      value={moment(payment.payment_date).format("DD/MM/YYYY")}
                      onChange={(e) => {
                        if (
                          moment(e.target.value, "DD/MM/YYYY", true).isValid()
                        ) {
                          handlePaymentChange(payment.id, {
                            ...payment,
                            payment_date: moment(
                              e.target.value,
                              "DD/MM/YYYY"
                            ).toISOString(),
                          });
                        }
                      }}
                    />
                  </Column>
                  <Column className="xs-12 sm-12 md-12 lg-2">
                    <Select
                      label={"Ödeme Türü"}
                      items={[
                        {
                          label: context.t(
                            `['receipt/detail/id'].payments.typeCASH`
                          ),
                          value: "0",
                        },
                        {
                          label: context.t(
                            `['receipt/detail/id'].payments.typeCARD`
                          ),
                          value: "1",
                        },
                        {
                          label: context.t(
                            `['receipt/detail/id'].payments.typeEFT`
                          ),
                          value: "2",
                        },
                        {
                          label: context.t(
                            `['receipt/detail/id'].payments.typePOINT`
                          ),
                          value: "3",
                        },
                      ]}
                      selected={String(Number(payment.payment_type))}
                      labelKey="label"
                      valueKey="value"
                      handler={(payment_type) => {
                        handlePaymentChange(payment.id, {
                          ...payment,
                          payment_type: Number(payment_type),
                        });
                      }}
                    />
                  </Column>
                  <Column className="xs-12 sm-12 md-12 lg-2">
                    <Select
                      label={"İşlem Adı"}
                      items={saleItemOptions}
                      selected={payment.sale_id || null}
                      labelKey="label"
                      valueKey="value"
                      handler={(item) => {
                        const selectedItem =
                          item && typeof item === "object"
                            ? item
                            : { value: item, type: null };
                        handlePaymentChange(payment.id, {
                          ...payment,
                          sale_id: selectedItem.value,
                          sale_type: selectedItem.type,
                        });
                      }}
                    />
                  </Column>
                  <Column className="xs-12 sm-12 md-12 lg-2">
                    <Select
                      label={"Personel"}
                      items={staffs}
                      selected={payment.staff_id || ""}
                      labelKey="full_name"
                      valueKey="id"
                      handler={(staff_id) => {
                        handlePaymentChange(payment.id, {
                          ...payment,
                          staff_id: parseInt(staff_id),
                        });
                      }}
                    />
                  </Column>
                  <Column className="xs-12 sm-12 md-12 lg-2">
                    <Input
                      label={"Tutar"}
                      type="text"
                      value={
                        paymentDetailValue[payment.id] !== undefined
                          ? paymentDetailValue[payment.id]
                          : payment.pay_amount
                          ? payment.pay_amount.toString()
                          : ""
                      }
                      onChange={(e) => {
                        const inputText = e.target.value.replace(/[^\d]/g, "");
                        setPaymentDetailValue({
                          ...paymentDetailValue,
                          [payment.id]: inputText,
                        });
                      }}
                      onBlur={() => {
                        if (paymentDetailValue[payment.id] !== undefined) {
                          const value =
                            paymentDetailValue[payment.id] === ""
                              ? 0
                              : parseFloat(paymentDetailValue[payment.id]);
                          handlePaymentChange(payment.id, {
                            ...payment,
                            pay_amount: value,
                          });
                        }
                      }}
                    />
                  </Column>
                  <Column className="xs-12 sm-12 md-12 lg-1">
                    <Delete
                      onClick={() => handleDeletePayment(payment.id)}
                      size="small"
                      style={{
                        cursor: "pointer",
                        color: "red",
                        width: "20px",
                        height: "20px",
                        marginTop: "15px",
                      }}
                    />
                  </Column>
                </Grid>
              ))}
            </div>
          )}
        </React.Fragment>
      ))}
    </>
  );
};

export default GroupedPaymentsList;
